export default __webpack_public_path__ + "static/media/team_guna_call_us_for_home_tour.4a8b7881.png";